import { createStore } from 'vuex'
import home from './modules/home'
import imageBrowsing from './modules/imageBrowsing'
import electronicFilm from './modules/electronicFilm'
import historyCheck from './modules/historyCheck'
import imageAndText from './modules/imageAndText'
import getters from './getters'

export default createStore({
  modules: {
    home,
    imageBrowsing,
    electronicFilm,
    historyCheck,
    imageAndText
  },
  getters
})
